
import { Component, Input, OnChanges, OnInit, SimpleChanges, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService } from 'src/app/services/api.service';
import { candidateModel } from 'src/app/services/candidateModel';
import { JobModel } from 'src/app/services/jobModel';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { TimezoneDatePipe } from '../../timezone-date.pipe';
import { CommonSkeletonComponent } from '../../skeleton/common-skeleton/common-skeleton.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


import { ScrollIntentGate } from 'src/app/shared/scroll-intent-gate';
@Component({
  selector: 'app-job-publishto',
  standalone: true,
  imports: [CommonModule, TimezoneDatePipe, CommonSkeletonComponent,
InfiniteScrollModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './job-publishto.component.html',
  styleUrls: ['./job-publishto.component.scss']
})
export class JobPublishtoComponent implements OnInit, OnDestroy, OnChanges {
  // User-intent gate (src/app/shared/scroll-intent-gate.ts): after a page
  // lands, the next page needs a NEW physical input — a fast wheel flick's
  // smooth-scroll tail must not chain pages on its own.
  readonly scrollGate = new ScrollIntentGate({
    onArmAtBottom: () => this.onScrollDown(),
    isAtBottom: () => ScrollIntentGate.nearBottom(document.querySelector('.jc-v3-entity-details-body')),
  });

  ngOnInit(): void {
    this.scrollGate.attach();
  }

  ngOnDestroy(): void {
    this.scrollGate.detach();
  }

  stopScroll: boolean = false;
  eventlist: any[] = [];
  loadAPIcall: boolean = false;
  @Input() jobDetails: JobModel;
   @Input() candidateDetails: candidateModel;
   @Input() Event: any;
   prevAfterKey : string = '';
   userId=localStorage.getItem('userId')
  constructor(   private util: UtilService,
    private api: ApiService,) {}
      ngOnChanges(changes: SimpleChanges): void {
        if (changes?.jobDetails?.currentValue || changes?.candidateDetails?.currentValue) {
          this.jobDetails = changes?.jobDetails?.currentValue;
          this.candidateDetails = changes?.candidateDetails?.currentValue;
          if (this?.jobDetails?.jobId || this?.candidateDetails?.candidateId) {
            this.eventlist = [];
            this.stopScroll = false;
            this.obj.searchAfterKey = null;
            this.prevAfterKey = '';
            this.loadeventslist();

          }
        }
      }


  getAllNetworks(networks: string[]): string {
      return networks.join('\n');
    }



  transformActivityType(activityType: string): string {
    return activityType.replace(/_/g, ' ')
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  obj: any = {
    limit: 20, // Increase limit if needed to fetch more items per call
    searchAfterKey: null,
    entityId: null,
    entityType: null,
    activityType: null,
};

loadeventslist() {
  if (this.loadAPIcall) return; // Prevent multiple API calls at the same time

  this.loadAPIcall = true;
  this.obj.entityId = this.Event === "JOB" ? this.jobDetails?.jobId : this.candidateDetails?.candidateId;
  this.obj.entityType = this.Event === "JOB" ? "JOB" : "CANDIDATE";
  this.obj.activityType = this.Event === "JOB"
      ? "JOB_PUBLISHED,JOB_UPDATED,JOB_STATUS_UPDATED,JOB_CREATED"
      : "CANDIDATE_PUBLISHED,CANDIDATE_UPDATED,CANDIDATE_STATUS_UPDATED,CANDIDATE_CREATED";

  this.api.create("jobs/findJobCandidateActivities", this.obj).subscribe(
      (res) => {
          this.util.stopLoader();

          if (res.code === "00000") {
              const afterKey = res.data.searchAfterKey;

              if (this.prevAfterKey === afterKey || res.data.events.length === 0) {
                  this.stopScroll = true;
                   
                  this.loadAPIcall = false; this.scrollGate.pageLanded();
                  return;
              }

              // Use a Set to track unique activityId values
              const existingIds = new Set(this.eventlist.map(event => event.activityId));
              const newEvents = res.data.events.filter(event => !existingIds.has(event.activityId));

              if (newEvents.length === 0) {
                  this.stopScroll = true;

              } else {
                  this.eventlist = [...this.eventlist, ...newEvents.map((event) => {
                      const data = event.data || {};
                      event.networks = [
                          ...(data.postedToMarketPlace || []),
                          ...(data.personalNetworks || []),
                          ...(data.memberNetworks || []),
                          ...(data.businessNetworks || [])
                      ].filter(Boolean);
                      return event;
                  })];

                  // Detect end-of-data on a partial last page so the
                  // "you've reached the bottom" footer renders without
                  // waiting for the user to trigger another empty fetch.
                  // For short lists that fit in the viewport, infinite-scroll
                  // never fires, so without this the footer would never show.
                  if (res.data.events.length < this.obj.limit || !afterKey) {
                      this.stopScroll = true;
                  }
              }

              this.prevAfterKey = afterKey;
          }

          this.loadAPIcall = false; this.scrollGate.pageLanded(); // Reset API call flag
      },
      (error) => {
          this.util.stopLoader();
          this.loadAPIcall = false; this.scrollGate.pageLanded();

          Swal.fire({
              icon: "error",
              title: "Error",
              text: "Something went wrong. Please try again later.",
              showConfirmButton: false,
              timer: 4000,
          });
      }
  );
}

onScrollDown() {
  if (!this.stopScroll && this.obj.searchAfterKey !== this.prevAfterKey && this.scrollGate.armed) {
      this.obj.searchAfterKey = this.prevAfterKey;
      this.loadeventslist();
  }
}

  sortColumn: string = 'event';
sortAscending: boolean = true;

sortBy(column: string) {
  // Toggle the sorting order (ascending or descending)
  if (this.sortColumn === column) {
    this.sortAscending = !this.sortAscending;
  } else {
    this.sortColumn = column;
    this.sortAscending = true;
  }

  // Sort based on the 'createdOn' field regardless of the column clicked
  this.eventlist.sort((a, b) => {
    const dateA = new Date(a.createdOn);
    const dateB = new Date(b.createdOn);

    let comparison = dateA.getTime() - dateB.getTime();

    return this.sortAscending ? comparison : -comparison;
  });
}

}

